import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: ShowError General Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.ShowError.';

  public static readonly exceptionError = `${Id.prefix}exceptionError`;
}

export class LangShowError {
  private constructor() {}

  public static exceptionError(): string {
    return interpolate(Id.exceptionError);
  }
}

export class ShowErrorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(Id.exceptionError, 'Exception Error', 'Default error dialog title');
  }
}
